export const COMPONENT_BASE_CLASS = 'drawer';
